import * as React from 'react';
import { brandSchema, marketSchema } from 'data/schema';
import { userSession } from 'state/session';
import { user } from 'utils/auth/user';
import { initWhatfix, isWhatfixEnabled, openWhatfix, whatfixSupportedBrands } from 'utils/ui/whatfix';
import { getLocale } from 'i18n/locale';

const WhatfixButton: React.FC = () => {
  const session = userSession().useState();
  const brand = brandSchema.parse(session?.brand || user.brand);
  const market = marketSchema.parse(session?.market || user.market.iso3);
  const locale = session?.locale || getLocale(market);

  React.useEffect(() => {
    initWhatfix(locale, market, brand);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brand]);

  // Only render for supported brands when Whatfix is enabled
  if (!isWhatfixEnabled() || !whatfixSupportedBrands.includes(brand)) {
    return null;
  }

  return (
    <div
      data-testid="whatfix-button"
      className="flex size-8 cursor-pointer items-center justify-center rounded-full bg-white"
      role="button"
      tabIndex={-1}
      onClick={openWhatfix}
      title="Whatfix"
    >
      <p className="text-teal-700">?</p>
    </div>
  );
};

export default WhatfixButton;
